import moment from "moment";

// if after combined details
// the length of the current page is greater than 10 then 
// cut it to 10
// the leftover will be saved somewhere

// if hit 10 rendered
// mp will request another page

export const groupTransactionHistoryByMonth = (
  transactions,
  groupedTransactions
) => {
  for (const transaction of transactions) {
    const date = moment(
      transaction.submittedDate
        ? transaction.submittedDate
        : transaction.completedDate
    )
      .utcOffset("+0800")
      .format("DD MMM YYYY");
    const month = moment(
      transaction.submittedDate
        ? transaction.submittedDate
        : transaction.completedDate
    ).format("MMMM");
    const year = new Date(
      transaction.submittedDate
        ? transaction.submittedDate
        : transaction.completedDate
    ).getFullYear();
    const id = groupedTransactions.length + 1;

    if (transaction.status === "1" || transaction.status === "2") {
      continue;
    }

    if (transaction.status === "9") {
      if (
        (transaction.processingDate === null ||
          transaction.completedDate === null) &&
        transaction.type !== "CoolOff"
      ) {
        continue;
      }
    }

    const found = groupedTransactions.some(
      value => value.month === month && value.year === year
    );
    if (found) {
      const index = groupedTransactions.findIndex(
        value => value.month === month && value.year === year
      );

      const foundDate = groupedTransactions[index].data.some(
        value => value.date === date
      );

      if (foundDate) {
        const dateIndex = groupedTransactions[index].data.findIndex(
          value => value.date === date
        );

        groupedTransactions[index].data[dateIndex].data = [
          ...groupedTransactions[index].data[dateIndex].data,
          transaction,
        ];
      } else {
        groupedTransactions[index].data = [
          ...groupedTransactions[index].data,
          { date: date, data: [transaction] },
        ];
      }
    } else {
      groupedTransactions.push({
        id: id,
        month: month,
        year: year,
        data: [
          {
            date: date,
            data: [transaction],
          },
        ],
      });
    }
  }

  return groupedTransactions;
};
